class VideoTimedBlocks extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.frame') || document;
    this.blocks = Array.from(this.querySelectorAll('[data-timed-block]'));

    this.blocks.forEach((block) => {
      block.addEventListener('click', () => {
        this.highlight(block);
        this.seek(this.toSeconds(block.dataset.start));
      });
    });

    this.highlight(this.blocks[0]);
    this.timer = setInterval(() => this.tick(), 250);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  get video() {
    return this.scope.querySelector('video');
  }

  toSeconds(value) {
    const p = String(value || '0').trim().split(':').map(Number);
    if (p.some(isNaN)) return 0;
    if (p.length === 3) return p[0] * 3600 + p[1] * 60 + p[2];
    if (p.length === 2) return p[0] * 60 + p[1];
    return p[0];
  }

  seek(seconds) {
    const v = this.video;
    if (!v) return;

    v.currentTime = seconds;
    const playback = v.play();
    if (playback && playback.catch) playback.catch(() => {});

    // If the browser clamped the seek, try once more once it has buffered
    setTimeout(() => {
      if (Math.abs(v.currentTime - seconds) > 1.5) {
        v.addEventListener('canplay', () => { v.currentTime = seconds; }, { once: true });
      }
    }, 300);
  }

  tick() {
    const v = this.video;
    if (!v) return;
    const t = v.currentTime;

    const match = this.blocks.find((block) => {
      const start = this.toSeconds(block.dataset.start);
      const end = this.toSeconds(block.dataset.end);
      return t >= start && t < end;
    });

    if (match) this.highlight(match);
  }

  highlight(block) {
    if (!block || block === this.active) return;
    this.active = block;
    this.blocks.forEach((b) => b.classList.toggle('is-active', b === block));
  }
}

if (!customElements.get('video-timed-blocks')) {
  customElements.define('video-timed-blocks', VideoTimedBlocks);
}